import type { SxProps, Theme } from '@mui/material/styles';

/**
 * אחידות מסכי הגדרות חברה (פרטי חברה + שעות פעילות):
 * דיסקט כחול לשמירה, עיפרון אפור לעריכה, חיווי מהשרת — InlineSaveIndicator (וי ירוק / איקס אדום).
 */
export const companySettingsFieldIconSx = {
  edit: { fontSize: 22, color: 'text.secondary' } as SxProps<Theme>,
  save: { fontSize: 22, color: 'primary.main' } as SxProps<Theme>,
};
